const Fdata = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1676956497/T_P%20Site/IMG_20230217_102526_upa73y.jpg",
    name: "Prof. V.K. Dwivedi",
    post: "Chairman",
    designation: "Professor",
    department: "T&P Cell",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658461441/T_P%20Site/rajan2_enxe9f_xypqxy.jpg",
    name: "Dr. Rajan Mishra",
    post: "Coordinator",
    designation: "Assistant Professor",
    department: "ECE Department",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658460705/T_P%20Site/WhatsApp_Image_2022-07-20_at_11.30.40_AM_ndfve3.jpg",
    name: "Dr. Vinay Kumar Singh",
    post: "Member",
    designation: "Assistant Professor",
    department: "CE Department",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1658156321/faculty/IMGFaculty232_tdonqz.jpg",
    name: "Dr. Ravi Shankar",
    post: "Member",
    designation: "Assistant Professor",
    department: "Chemcial Engeering Department",
  },
  {
    id: 5,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658460477/T_P%20Site/75439220_2291369977821121_982916111936782336_n_i8pw3b.jpg",
    name: "Dr. Sushil Kumar Saroj",
    post: "Member",
    designation: "Assistant Professor",
    department: "CSE Department",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658460736/T_P%20Site/WhatsApp_Image_2022-07-20_at_2.08.16_PM_e9ywwf.jpg",
    name: "Dr. Shekhar Yadav",
    post: "Member",
    designation: "Assistant Professor",
    department: "EE Department",
  },
  {
    id: 7,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658461338/T_P%20Site/1613245239962_pgczh0.jpg",
    name: "Dr. D.S. Singh",
    post: "Member",
    designation: "Assistant Professor",
    department: "ITCA",
  },
  {
    id: 8,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658461210/T_P%20Site/citations_wiuhm2.jpg",
    name: "Dr. Prashant Saini",
    post: "Member",
    designation: "Assistant Professor",
    department: "ME Department",
  },
  {
    id: 9,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1676955801/T_P%20Site/WhatsApp_Image_2023-02-17_at_12.39.12_n7d2tz.jpg",
    name: "Dr. Bharti Shukla",
    post: "Member",
    designation: "Assistant Professor",
    department: "HMSD",
  },
  {
    id: 10,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658917765/T_P%20Site/photo_2022-07-27_15-58-36_nyxpqn.jpg",
    name: "Ms. Sukanya Pandey",
    post: "Placement Coordinator",
    designation: "Technical Staff",
    department: "T&P Cell",
  },
];

export default Fdata;
